import React, { useState } from "react";

export default function FileGstCalc() {
  const [gstValue, setGstValue] = useState({ amount: "", gst: "" });
  const [netAmount, setNetAmount] = useState("");
  const [inclusiveAmount, setInclusiveAmount] = useState(0);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setInclusiveAmount(null);
    setNetAmount(null);
    const { name, value } = e.target;
    setGstValue({ ...gstValue, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    let formIsValid = true;
    let err = {};
    if (!gstValue || !gstValue.amount) {
      err.amount = "* Please enter Amount";
      formIsValid = false;
    }
    if (!gstValue || !gstValue.gst) {
      err.gst = "* Please enter GST(%)";
      formIsValid = false;
    }
    setErrors(err);
    return formIsValid;
  };

  const handleCalculate = () => {
    if (validateForm()) {
      let price = gstValue?.amount;
      let taxvalue = price * (gstValue?.gst / 100);
      let total = parseInt(price) + taxvalue;
      setNetAmount(total);

      let gst = 1 + gstValue?.gst / 100;
      let goodsValue = gstValue?.amount / gst;
      setInclusiveAmount(goodsValue);
    }
  };
  return (
    <div>
      <div className="children-box-alignment">
        <div className="globally-gst-calculter">
          <div className="two-radio-button-alignment">
            <div>
              <input
                type="radio"
                name="type"
                id="inclusive"
                value="inclusive"
                defaultChecked
                onChange={(e) => handleChange(e)}
              />
              <span>GST Inclusive</span>
            </div>
            <div>
              <input
                type="radio"
                name="type"
                id="exclusive"
                value="exclusive"
                onChange={(e) => handleChange(e)}
              />
              <span>GST Exclusive</span>
            </div>
          </div>
          <div className="gst-input">
            <label>Amount</label>
            <input
              type="number"
              name="amount"
              placeholder="10000"
              value={gstValue?.amount}
              onChange={(e) => {
                Number(e.target.value) >= 0 && handleChange(e);
              }}
              className={errors?.amount && "error-input"}
            />{" "}
            <span className="text-sm text-red-700">{errors?.amount}</span>
          </div>
          <div className="gst-input">
            <label>GST</label>
            <input
              type="number"
              name="gst"
              placeholder="18"
              value={gstValue?.gst}
              onChange={(e) => {
                Number(e.target.value) >= 0 && handleChange(e);
              }}
              className={errors?.gst && "error-input"}
            />{" "}
            <span className="text-sm text-red-700">{errors?.gst}</span>
          </div>
        </div>
        <div className="gst-two-button-center-alignment">
          <div className="button">
            <button onClick={() => handleCalculate()}>Calculate GST</button>
          </div>
        </div>
        {gstValue?.type == "exclusive" ? (
          <div className="gst-result-box">
            <div className="text-alignment">
              <p>Gross Amount </p>
              <span>{gstValue?.amount}</span>
            </div>
            <div className="text-alignment">
              <p>GST (%)</p>
              <span>{gstValue?.gst}</span>
            </div>
            <div className="text-alignment">
              <p>Net Amount (excluding GST)</p>
              <span>{netAmount}</span>
            </div>
          </div>
        ) : (
          <div className="gst-result-box">
            <div className="text-alignment">
              <p>Net Amount </p>
              <span>{gstValue?.amount}</span>
            </div>
            <div className="text-alignment">
              <p>GST (%)</p>
              <span>{gstValue?.gst}</span>
            </div>
            <div className="text-alignment">
              <p>Gross Amount (including GST)</p>
              <span>{inclusiveAmount?.toFixed(2)}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
